import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const FarawayIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", color: "#5F6E7D", ...props, children: [
    /* @__PURE__ */ jsx("path", { d: "M8.72975 11.3411H4.76782L4 16H7.95539L8.72975 11.3411Z", fill: "currentColor" }),
    /* @__PURE__ */ jsx("path", { d: "M10.8168 9.72906L4.96868 10.1224L6.30731 2H14L12.6173 5.30504H9.7198L9.39018 7.32891H11.8138L10.8168 9.72906Z", fill: "currentColor" })
  ] });
};

export { FarawayIcon };
//# sourceMappingURL=farawayIcon.esm.js.map
